const cards = [];
cards[0] = 'ClubsA';
cards[1] = 'Clubs2';
cards[2] = 'Clubs3';
cards[3] = 'Clubs4';
cards[4] = 'Clubs5';
cards[5] = 'Clubs6';
cards[6] = 'Clubs7';
cards[7] = 'Clubs8';
cards[8] = 'Clubs9';
cards[9] = 'Clubs10';
cards[10] = 'ClubsJ';
cards[11] = 'ClubsQ';
cards[12] = 'ClubsK';
cards[13] = 'SpadesA';
cards[14] = 'Spades2';
cards[15] = 'Spades3';
cards[16] = 'Spades4';
cards[17] = 'Spades5';
cards[18] = 'Spades6';
cards[19] = 'Spades7';
cards[20] = 'Spades8';
cards[21] = 'Spades9';
cards[22] = 'Spades10';
cards[23] = 'SpadesJ';
cards[24] = 'SpadesQ';
cards[25] = 'SpadesK';
cards[26] = 'DiamondsA';
cards[27] = 'Diamonds2';
cards[28] = 'Diamonds3';
cards[29] = 'Diamonds4';
cards[30] = 'Diamonds5';
cards[31] = 'Diamonds6';
cards[32] = 'Diamonds7';
cards[33] = 'Diamonds8';
cards[34] = 'Diamonds9';
cards[35] = 'Diamonds10';
cards[36] = 'DiamondsJ';
cards[37] = 'DiamondsQ';
cards[38] = 'DiamondsK';
cards[39] = 'HeartsA';
cards[40] = 'Hearts2';
cards[41] = 'Hearts3';
cards[42] = 'Hearts4';
cards[43] = 'Hearts5';
cards[44] = 'Hearts6';
cards[45] = 'Hearts7';
cards[46] = 'Hearts8';
cards[47] = 'Hearts9';
cards[48] = 'Hearts10';
cards[49] = 'HeartsJ';
cards[50] = 'HeartsQ';
cards[51] = 'HeartsK';
export default cards;



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/games/hi-lo/card-map.ts